'use strict';

const { h } = require('phy');

const renderNotification = (
  displayNotification,
  {
    success: successText,
    failure: { enroll: failureEnrollText, load: failureLoadText },
  }
) => {
  switch (displayNotification) {
    case 'notification_success': {
      return h('div.notification.success', successText);
    }
    case 'error_system': {
      return h('div.alert.error.system', failureEnrollText);
    }
    case 'error_load': {
      return h('div.alert.error.load', failureLoadText);
    }
    default: {
      return '';
    }
  }
};

module.exports = ({ displayNotification, notificationText }) => {
  return h(
    'div.select-alerts#select-notification',
    renderNotification(displayNotification, notificationText)
  );
};
